import "./Locations.css"
import '../styles/font.css';

export default function(){
    const phoneNumber = "+201007772199";
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    return(<div className="location" dir="rtl" id="loc">
        <div className="first">
            <h3 className="title">
        عيادة القاهرة
              <img src="\assets\Vector (1).svg"/> 
                </h3>

            <p className="discription">
                الدقي ميدان المساحه بجوار السفاره اليمنيه شارع هارون الدور الرابع عماره122
            </p>
            <div className="foot"><a href={whatsappUrl} className="whatsapp-link" target="_blank" rel="noopener noreferrer">إحجز معادك</a>
            </div>        </div>
        <div className="second">
        <h3 className="title">عيادةالفيوم
        <img src="\assets\Vector (1).svg"/> 
        </h3>
            <p className="discription">
            دله امتداد ميدان المسله بعد سوبر ماركت العماد برج الهادي الدور الاول
                </p>
            <div className="foot"><a href={whatsappUrl} className="whatsapp-link" target="_blank" rel="noopener noreferrer">إحجز معادك</a>
            </div>        </div>
        <div className="third">
        <h3 className="title">عيادة طنطا
        <img src="\assets\Vector (1).svg"/> 
        </h3>
            <p className="discription">
                ميدان الساعه بجوار قسم اول شارع البورصه مول الشهاوي الدور الاول 

            </p>
            <div className="foot"><a href={whatsappUrl} className="whatsapp-link" target="_blank" rel="noopener noreferrer">إحجز معادك</a>
            </div>
        </div>

    </div>)
}